define(
    'FacetItemsInfo1.View'
    , [
        'SCView',
        'facetitemsinfo1.tpl'
    ]
    , function (
        SCViewModule,
        facetItemsInfo1_tpl
    ) {
    
    'use strict';

    var SCView = SCViewModule.SCView;

    var firstFacetItemField = '';

    function FacetItemsInfo1View(options) {

        SCView.call(this, options);
        this.template = facetItemsInfo1_tpl;
        this.contextDataRequest = ['item'];
        this.config = options.Data;

    }

    FacetItemsInfo1View.prototype = Object.create(SCView.prototype);
    FacetItemsInfo1View.prototype.constructor = FacetItemsInfo1View;

    FacetItemsInfo1View.prototype.getContext = function () {

        var itemField = this.config.itemfieldsOne;
        firstFacetItemField = this.contextData.item()[itemField];

        return {

            source: firstFacetItemField
        };
    }

    return FacetItemsInfo1View;
});
